import React, { Component } from "react";
import FlexView from "react-flexview";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import * as R from "ramda";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import Container from "../../../../../modules/commons/Container";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import ReportStatisticProspectToday from "./components/reportStatisticProspectToday";
import ReportAppointmentFollowupToday from "./components/reportAppointmentFollowupToday";
import ReportAppointmentOverdue from "./components/reportAppointmentOverdue";
import { mapToObjectDDL, removeNullFields } from "../../../../common/mapper";
import { monthOptions, yearOptions } from "../config";
import { HttpStatus } from "../../../../common/Constants";
import ErrorAction from "../../../../../Redux/ErrorRedux";
import { connect } from "react-redux";

class ProspectDaily extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isAllSelected: true,
            isSpecificSelected: false,
            dataCabang: [],
            dataTL: [],
            kodeCabang: null,
            search: [],
            tableConfig: [],
            teamLead: null,
            dataTable: [],
            doSearch: false,
        };
    }

    componentDidMount = async () => {
        this.setState((prevValue) => ({
            ...prevValue,
        }));
        await this.fetchDataCabang();
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({ ...prevValue, loading: !prevValue.loading }));
    };

    fetchDataCabang = async () => {
        this.handleTriggerLoading();
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
            setError: this.props.setError,
            menuName: "Dashboard Level Kepala Cabang Keatas dan Admin CRM - Laporan Statistik Prospek Cabang",
            args: null,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            let filteredData = res.data.data.filter(
                item => this.props.menuAccess.map(data => data.idRefObj).includes(item.kodeCabang)
            );

            if (filteredData.length !== 0) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataCabang: filteredData,
                }))
            }

        }
        this.handleTriggerLoading();
    };

    fetchDataTL = async (kodeCabang) => {
        this.handleTriggerLoading();
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterSales,
            setError: this.props.setError,
            menuName: "Dashboard Level Kepala Cabang Keatas - Laporan Harian By Tipe By Team Leader",
            args: { paramFilters: { kodeCabang: kodeCabang, userNameLead: this.props.auth.user.username } },
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                dataTL: res.data.data,
            }));
        }
        this.handleTriggerLoading();
    };

    handleSearchValueChange = async (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
        }));
        if (R.equals(name, "kodeCabang")) {
            this.setState((prevValue) => ({
                ...prevValue,
                teamLead: null,
            }));
            if(!value) return
            await this.fetchDataTL(value.value);
        }
    };

    handleSearch = () => {
        const { kodeCabang, teamLead } = this.state;

        this.setState((prevValue) => ({
            ...prevValue,
            search: removeNullFields({
                kodeCabang: kodeCabang?.value,
                teamLeaderEmployeeId: teamLead?.value,
                salesId: null
            }),
            doSearch: true,
        }));
    };

    render() {
        return (
            <div>
                <Container>
                    <FlexView style={{ gap: "20px", alignItems: "center" }}>
                        <FlexView style={{ gap: "20px", alignItems: "flex-end" }}>
                            <SimpleDDL
                                id="select_options_kode_cabang"
                                box="search"
                                name="kodeCabang"
                                isClearable
                                containerclassname="width width-250px"
                                placeholder="Nama Cabang"
                                menuPosition="fixed"
                                options={
                                    this.state.dataCabang.map(
                                        item => mapToObjectDDL(item.namaDealer, item.kodeCabang)
                                    )
                                }
                                value={this.state.kodeCabang}
                                onChange={(value, { name }) => this.handleSearchValueChange(name, value)}
                            />
                            <SimpleDDL
                                id="select_options_team_lead"
                                box="search"
                                name="teamLead"
                                containerclassname="width width-250px"
                                placeholder="Nama TL"
                                menuPosition="fixed"
                                isClearable
                                options={this.state.dataTL.map(item => mapToObjectDDL(item.salesLeadName, item.employeeId))}
                                value={this.state.teamLead}
                                onChange={(value, { name }) => this.handleSearchValueChange(name, value)}
                            />
                        </FlexView>
                        <SimpleButton
                            styles={{ marginBottom: "15px" }}
                            onClick={this.handleSearch}
                        >Cari</SimpleButton>
                    </FlexView>
                    <Tabs>
                        <TabList>
                            <Tab style={{ width: "150px", textAlign: "center" }}>
                                Laporan Statistik Prospek Today
                            </Tab>
                            <Tab style={{ width: "200px", textAlign: "center" }}>
                                Laporan Appointment Follow Up Hari Ini
                            </Tab>
                            <Tab style={{ width: "200px", textAlign: "center" }}>
                                Laporan Appointment Overdue
                            </Tab>
                        </TabList>
                        <TabPanel>
                            <ReportStatisticProspectToday
                                {...this.props}
                                search={this.state.search}
                                doSearch={this.state.doSearch}
                                onSearchValueChange={this.handleSearchValueChange}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                        <TabPanel>
                            <ReportAppointmentFollowupToday
                                {...this.props}
                                search={this.state.search}
                                doSearch={this.state.doSearch}
                                onSearchValueChange={this.handleSearchValueChange}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                        <TabPanel>
                            <ReportAppointmentOverdue
                                {...this.props}
                                search={this.state.search}
                                doSearch={this.state.doSearch}
                                onSearchValueChange={this.handleSearchValueChange}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                    </Tabs>
                </Container>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProspectDaily);